export const environment = {
    production: false,
    microsoftTenantId: 'eab72f59-0def-41b1-8c74-9f4f0d50124f',
    staffInterfaceUrl: 'https://staff.cargosprintgroup.com',
    firebase: {
        apiKey: 'AIzaSyDDQV0_NOrp84eKoF1uAzmztpORxi1DO94',
        authDomain: 'cert-test-530d3.firebaseapp.com',
        projectId: 'cert-test-530d3',
        storageBucket: 'cert-test-530d3.firebasestorage.app',
        messagingSenderId: '38924733139',
        appId: '1:38924733139:web:64a35a6272d158e2d6e226',
    },
} as const;
